document.addEventListener('DOMContentLoaded', function () {
  // Mobiles Menü
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Variantenauswahl mit verstecktem Formularfeld synchronisieren
  var variantSelect = document.querySelector('[data-variant-select]');
  var variantInput = document.querySelector('[data-variant-id]');
  if (variantSelect && variantInput) {
    variantSelect.addEventListener('change', function () {
      variantInput.value = variantSelect.value;
    });
  }

  // Mengensteuerung
  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      if (input) input.value = parseInt(input.value, 10) + 1;
    });
  });
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      if (input && parseInt(input.value, 10) > 1) input.value = parseInt(input.value, 10) - 1;
    });
  });

  // Produktbild-Thumbnails
  var mainImage = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.getAttribute('data-large');
    });
  });
});
